import { Collection, Response } from "vue-mc";
import CollectionFilter from "@/collections/CollectionFilter";
import BaseModel from "@/models/BaseModel";
import { AUTH_LOGOUT } from "@/store/action-types";
import store from '@/store';

export default class BaseCollection extends Collection {
  _directory_cache = {};
  _directory_requests = {};

  constructor() {
    super();

    this.resetFilter();
  }
  defaults() {
    return {
      count: 0,
    };
  }
  routes() {
    throw new Error("Implement collection routes method");
  }
  methods() {
    return {
      fetch: "GET",
      fetchDirectory: "GET",
    };
  }
  resetFilter() {
    this.Filter = new CollectionFilter();
    this.prepareFilter(this.Filter);

    return this;
  }
  prepareFilter(CollectionFilter) {
    return CollectionFilter;
  }
  getFilter() {
    return this.Filter;
  }
  setFilter(Filter) {
    if (typeof Filter === "object") {
      this.Filter = Filter;
    }

    return this;
  }
  getModelsFromResponse(response) {
    const { data, total } = response.getData();
    const models = data ? data.map((insert) => new (this.model())(insert)) : [];

    if (total) {
      this.set("count", total);
    }

    return models;
  }
  createRequest(config) {
    const token = localStorage.getItem("auth__access_token");
    const filter_query = this.getFilter().getQuery();

    config.headers = config.headers || {};

    token && (config.headers["Authorization"] = `Bearer ${token}`);
    filter_query.length && (config.url += `?${filter_query}`);

    return new super.createRequest(config);
  }

  handleCustomFetchSuccess(response) {
    this.onFetchSuccess(response);

    return response;
  }

  /**
   * This is an override of the base onFetchFailure from the vue-mc library
   * @param response 
   * @returns 
   */
  onFetchFailure(response) {

    if (response.response.response.status === 401) {
      store.dispatch(AUTH_LOGOUT).then(() => {
        window.location.href = "#/login";
      });
    }

    return response;
  }

  handleCustomFetchFailure(response) {
    console.log('start here')
    this.onFetchFailure(response);

    console.log('HANDLE CUSTOM FETCH FAILURE')

    return response;
  }

  sortBy(field) {
    return this.models.sort((a, b) => {
      if (a[field] > b[field]) {
        return 1;
      }

      if (b[field] > a[field]) {
        return -1;
      }

      return 0;
    });
  }

  hasByID(model) {

    if (model instanceof BaseModel) {
      return this.map((v) => v).filter(({ id }) => id === model.id).length;
    }
    else if (model === null) {
      return this.map((v) => v).filter(({ id }) => id === model).length;
    }
    else if (model instanceof "string") {
      return this.map((v) => v).filter(({ id }) => id === model).length;
    }

    return false;
  }

  getByID(model) {
    if (model instanceof BaseModel) {
      return this.map((v) => v).find(({ id }) => id === model.id);
    } else if (typeof model === "string") {
      return this.map((v) => v).find(({ id }) => id === model);
    }

    return false;
  }

  fetchDirectory(directory, params) {
    const method = this.getOption("methods.fetchDirectory");
    const route = this.getRoute("fetchDirectory");
    const url = this.getURL(route, { directory });

    return (this._directory_requests[directory] = this.createRequest({
      method,
      url,
      params,
    })
      .send()
      .then((response) => {
        if (
          response instanceof Response &&
          response.response.status === 200 &&
          response.response.data
        ) {
          this.emit("fetchDirectory", {
            error: null,
            key: directory,
            directory: response.response.data,
          });

          return response.response.data;
        } else {
          this.emit("fetchDirectory", {
            error: "Directory not available",
            key: directory,
          });

          return [];
        }
      }));
  }
}
